import { render, staticRenderFns } from "./WithdrawalOrderGuidelines.vue?vue&type=template&id=4ce290e7&scoped=true"
import script from "./WithdrawalOrderGuidelines.vue?vue&type=script&lang=js"
export * from "./WithdrawalOrderGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce290e7",
  null
  
)

export default component.exports